import(/* webpackMode: "eager" */ "/vercel/path0/app/terms/terms-content.tsx")